<template>
  <div v-show="isShow" :class="['register-mask-contaienr', registerClass]">
    <div class="close-mask" @click="handleMask"></div>
    <div class="register-card-container">
      <div class="register-card-left">
        <div
          v-if="userPlatform !== 2 && formType === 'register'"
          class="left-register-card"
        >
          <img
            class="register-website-icon"
            src="../../assets/images/fir-class/bottom-icon.png"
            alt=""
          />
          <div class="left-register-card-content">
            <div class="left-register-card-title">注册即可获得免费权限</div>
          </div>
          <div class="left-register-card-head">
            <div>Hello!</div>
            <div>欢迎注册</div>
          </div>
        </div>
        <div
          v-if="userPlatform !== 2 && formType === 'login'"
          class="left-login-card"
        >
          <div class="left-login-card-title">完善信息</div>
          <div>方便我们为您提供更精准的服务</div>
        </div>
        <div
          v-if="userPlatform !== 2 && formType === 'registerSuccess'"
          class="left-register-card"
        >
          <img
            class="register-website-icon"
            src="../../assets/images/fir-class/bottom-icon.png"
            alt=""
          />
        </div>
      </div>
      <!-- <AddForm
        ref="addForm"
        v-show="showForm('login')"
        :userTypes="registerTypes"
        @hideCard="hideCard"
      /> -->
      
      <PhoneForm
        v-show="showForm('register')"
        @registerFormAfter="registerFormAfter"
        @hideCard="hideCard"
        @setUserInfo="setUserInfo"
      />
      <SuccessForm 
        :userInfo="userInfo"
        v-show="showForm('registerSuccess')" 
        @hideCard="hideCard" />
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import AddForm from "./AddForm.vue";
import PhoneForm from "./PhoneForm.vue";
import SuccessForm from "./SuccessForm.vue";

import { validateSymbols, validateChinese } from "@/utils/formValidate.js";

export default {
  components: {
    AddForm,
    PhoneForm,
    SuccessForm,
  },
  data() {
    return {
      isShow: false,
      logName: "",
      sourceId: "",
      userInfo:null,
      userTypes: [1, 2],
      // 1:个人； 2： 企业
      registerTypes: 2,
      // formType: 'register', 'login'
      formTypes: ["register", "login", "registerSuccess"],
      formType: "",

      // tuiguangIds: {
      //   bi4b5ce2fe28308fd9: {
      //     value: 3,
      //     name: "百度推广链接",
      //   },
      //   bia0b376535542b996: {
      //     value: 4,
      //     name: "微信公众号推广链接",
      //   },
      //   bi7d044d37cc9a1cf2: {
      //     value: 5,
      //     name: "发文推广链接",
      //   },
      //   bid37727346450a16b: {
      //     value: 6,
      //     name: "编辑号注册",
      //   },
      // },
      tuiguangIds: {
        1: {
          value: 1,
          name: "百度推广链接",
        },
        0: {
          value: 0,
          name: "网站",
        },
        6: {
          value: 6,
          name: "编辑号注册",
        },
      },
    };
  },
  computed: {
    ...mapState({
      userPlatform: (state) => state.user.userPlatform,
    }),
    showForm() {
      return (formname) => {
        if (this.formType === formname) {
          return true;
        }
        return false;
      };
    },
    registerClass() {
      if (this.userPlatform === 2) {
        return "register-mask-windows-contaienr";
      }
      return "";
    },
  },
  watch: {
    "$route.query.formType": {
      handler() {
        this.initFormType();
      },
      immediate: true,
    },
  },
  created() {
    // this.initFormType();
  },
  mounted() {
    this.initWebInfo();
  },
  methods: {
    ...mapMutations("user", {
      setUserLogname: "setUserLogname",
      setUserSourceId: "setUserSourceId",
    }),
    initWebInfo() {
      const routequery = this.$route.query;
      const logname = routequery.logname || routequery.admLogName;
      const queryLogname = parseInt((logname - 678 + 456) / 123);

      let sourceId = routequery.sourceId || routequery.source;

      if (sourceId) {
        if (this.tuiguangIds[sourceId] || this.tuiguangIds[sourceId] === 0) {
          sourceId = this.tuiguangIds[sourceId]["value"];
          this.sourceId = parseInt(sourceId);

          this.setUserSourceId(sourceId);
        }
      }
      if (queryLogname) {
        this.logName = parseInt(queryLogname);
        this.setUserLogname(queryLogname);
      }
    },
    initFormType() {
      const currentQuery = this.$route.query;
      const formType = currentQuery["formType"];
      const userType = parseInt(currentQuery["userType"]);

      let findFormType = this.formTypes.find((item) => item === formType);
      let findUserType = this.userTypes.find((item) => item === userType);

      if (findFormType) {
        this.formType = findFormType;
        this.isShow = true;
      } else {
        this.isShow = false;
        // this.formType = this.formTypes[0];
      }

      if (findUserType) {
        this.registerTypes = findUserType;
      } else {
        this.registerTypes = this.userTypes[0];
      }

      // this.$router.push({
      //   path: this.$route.path,
      //   query: {
      //     ...currentQuery,
      //     formType: this.formType ? this.formType : undefined,
      //   },
      // });
    },
    registerFormAfter(registerTypes) {
      this.registerTypes = parseInt(registerTypes);
      this.formType = "login";


      const currentQuery = this.$route.query;
      // this.$router.push({
      //   path: this.$route.path,
      //   query: {
      //     ...currentQuery,
      //     formType: this.formType,
      //     userType: this.registerTypes,
      //   },
      // });
      this.$router.push({
        path: this.$route.path,
        query: {
          ...currentQuery,
          formType: "registerSuccess",
        },
      });
    },
    showCard() {
      this.isShow = true;
      // const currentQuery = this.$route.query;

      // this.$router.push({
      //   path: this.$route.path,
      //   query: {
      //     ...currentQuery,
      //     formType: this.formType,
      //     userType: this.registerTypes,
      //   },
      // });
    },

    setUserInfo(userInfo){
      this.userInfo = userInfo
    },

    handleMask() {
      this.$refs["addForm"]["handleMask"]();
    },
    hideCard() {
      // this.isShow = false;
      const currentQuery = this.$route.query;

      this.$router.push({
        path: this.$route.path,
        query: {
          ...currentQuery,
          formType: undefined,
          userType: this.registerTypes,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.register-mask-contaienr {
  position: fixed;
  width: 100vw;
  height: 100vh;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba($color: #000000, $alpha: 0.6);

  .close-mask {
    position: absolute;
    z-index: 15;

    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }

  .register-card-container {
    position: relative;
    z-index: 20;
    display: flex;
    flex-flow: column;
    align-items: stretch;
    flex-basis: 1;
    flex-grow: 1;
    min-width: 0;
    min-height: 100vh;

    background: #ffffff;

    .register-card-left {
      width: 100%;
      // height: 200px;
      // min-height: 200px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-image: url(../../assets/home/sm-registerbg.png);
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center center;

      .left-register-card {
        position: relative;
        width: 100%;
        height: 200px;
        padding: 20px 0;
        text-align: center;
        .register-website-icon {
          width: 110px;
          height: 72px;
          object-fit: contain;
        }
        .left-register-card-content {
          font-size: 20px;
          color: #ffffff;
        }
        .left-register-card-head {
          box-sizing: border-box;
          position: absolute;
          bottom: -30%;
          left: 3%;
          text-align: left;
          width: 94%;
          background-color: #ffffff;
          color: #333333;
          padding: 20px;
          font-size: 24px;
          font-family: Microsoft YaHei;
          font-weight: 400;
        }
      }
      .left-login-card {
        width: 100%;
        height: 200px;
        padding: 40px 0;
        text-align: center;
        color: #ffffff;

        .left-login-card-title {
          font-size: 20px;

          font-weight: 500;
          color: #fffefe;
          line-height: 42px;
        }
      }
    }

    .register-card-main {
      position: relative;

      flex-basis: 1;
      flex-grow: 1;
      padding: 18px;
      padding-bottom: 0;

      .re-head-line {
        margin-bottom: 30px;
        .re-title {
          display: inline-block;
          font-size: 22px;

          font-weight: 500;
          color: #333333;
        }
        .re-subtitle {
          padding-left: 2rem;
          display: inline-block;

          font-weight: 400;
          color: #333333;
        }
      }

      .re-form-container {
        .re-form-item {
          margin-bottom: 10px;

          .re-input {
            width: 100%;
            // width: 356px;
            height: 44px;
            border: 1px solid #e4e5eb;
            padding: 10px;
            &::placeholder {
              color: #c0c4cc;
            }
          }

          .re-submit {
            margin: 20px 0;
            width: 100%;
            height: 44px;
            line-height: 44px;
            text-align: center;
            background: #2b304d;
            color: #ffffff;
            border: none;
            cursor: pointer;
          }
        }
        .form-select-line {
          display: flex;
          .main-select {
            flex-basis: 1;
            flex-grow: 2;
          }
          .sub-select {
            flex-basis: 1;
            flex-grow: 1;
            margin-left: 10px;
          }
          .form-select {
            border: 1px solid #e4e5eb;
            height: 44px;
            line-height: 40px;
            padding: 0 0.5rem;
            color: #666666;
          }

          .form-select:focus {
            outline: none;
          }

          .form-select::-ms-expand {
            background-color: #ffffff;
            border: none;
          }
        }
      }

      .re-card-bottom-tip {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        background-color: #f5f6f9;
        height: 30px;
        line-height: 30px;
        text-align: center;

        font-size: 12px;

        font-weight: 400;
        color: #333333;
      }
    }
  }
}

.register-mask-windows-contaienr {
  flex-flow: row;

  .register-card-container {
    flex-basis: 1;
    flex-grow: 0;
    flex-flow: row;

    min-width: 700px;
    max-width: 740px;
    min-height: 350px;
    .register-card-left {
      min-width: 260px;
      width: 260px;
      // min-height: 100%;

      background-image: url(../../assets/home/registerbg.png);
    }
    .register-card-main {
      padding: 30px 52px;
    }
  }
}
</style>